import React from "react";

export default function MethodTimeline({ steps = [], testIdPrefix = "method-step" }) {
  return (
    <ol className="space-y-12 md:space-y-16">
      {steps.map((s, i) => (
        <li
          key={i}
          className="tl-step grid grid-cols-[40px_1fr] gap-6 md:gap-10 reveal"
          data-testid={`${testIdPrefix}-${i + 1}`}
        >
          <div className="flex flex-col items-center pt-2">
            <span className="tl-dot" />
          </div>
          <div className="pb-2">
            <div className="flex items-baseline gap-4">
              <span className="font-serif italic text-[#9A7E47] text-2xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] tracking-tight leading-tight">
                {s.label}
              </h3>
            </div>
            <p className="mt-4 text-[#4A4A4A] text-lg md:text-xl leading-relaxed max-w-2xl">
              {s.body}
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
}
